import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { useReminder } from '../../../hooks/useReminder.tsx';
import { useChannelsService } from '../../../hooks/useChannelsService.tsx';
import PlayButton from '../../buttons/PlayButton.tsx';

export const AccountReminderNotification = () => {
    const { closeReminder, isVisible, reminder } = useReminder();
    const _channels = useChannelsService();
    const channel = _channels.channels.find(ch => ch.ch_id === Number(reminder?.targetId));
    const loggedInPlayButton = () =>
        <span
            className={'inline-block rounded-full bg-[#008DD2] border border-[#008dd2] hover:border-[#007CC1] hover:bg-[#007CC1] transition-colors py-1 px-4 focus:outline-hidden font-light tracking-wider'}>Oglądaj</span>;
    const loggedOutPlayButton = () =>
        <span
            className={'inline-block rounded-full bg-[#008DD2] border border-[#008dd2] hover:border-[#007CC1] hover:bg-[#007CC1] transition-colors py-1 px-4 focus:outline-hidden font-light tracking-wider'}>Zaloguj się</span>;
    const channelDescription = () => {
        if (channel?.enabled) {
            return <p>Rozpoczęcie transmisji. Oglądaj w BM GO lub na dekoderze na kanale <span
                className={'font-semibold'}>{channel?.name ?? ''}</span> (pozycja {channel?.position}).</p>;
        } else {
            <p>Rozpoczęcie transmisji. Oglądaj na dekoderze na kanale <span
                className={'font-semibold'}>{channel?.name ?? ''}</span> (pozycja {channel?.position}).</p>;
        }
    };
    return (
        <div
            className={`fixed z-50 rounded-lg bg-neutral-50 p-4 transition-all duration-500 animate-opacityEaseIn
  top-16 left-0 right-0 mx-auto w-[calc(100%-2rem)] max-w-none
  md:top-6 md:right-6 md:left-auto md:bottom-auto md:mx-0 md:w-full md:max-w-96
  ${isVisible ? 'translate-x-0 opacity-100' : 'translate-x-[150%] opacity-0'}`}>
            <div className="flex">
                <div className="shrink-0">
                    <InformationCircleIcon aria-hidden="true" className="size-6 text-neutral-900" />
                </div>
                <div className="ml-3 w-full">
                    <h3 className="text-sm font-medium text-neutral-700 line-clamp-2 text-ellipsis ">{reminder?.title ?? ''}</h3>
                    <div className="mt-2 text-sm text-neutral-700">
                        {channelDescription()}
                    </div>
                    <div className="mt-5">
                        <div className="-my-1.5 flex space-x-3">
                            {/* <Button size={ButtonSize.SMALL} variant={ButtonVariant.PRIMARY} className="border-0 ring-offset-neutral-50 py-1 font-medium focus:ring-offset-neutral-50 focus:ring-[#008DD2]"> Oglądaj</Button> */}
                            {channel?.enabled &&
                                <PlayButton channel={channel} loggedInElem={loggedInPlayButton()}
                                            loggedOutElem={loggedOutPlayButton()}
                                            withUnavailableModal={true} />
                            }
                            <button
                                type="button"
                                className="border border-neutral-300 rounded-full bg-neutral-50 px-5 py-1 font-base text-neutral-700 hover:bg-neutral-100 focus:outline-hidden focus:ring-2 focus:ring-neutral-600 focus:ring-offset-2 focus:ring-offset-neutral-50 transition-colors"
                                onClick={closeReminder}
                            >
                                Odrzuć
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
